import { hasValue } from 'globalutils/fmUtils';
import moment from 'moment';
import React, { lazy, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import { getConfig } from './config';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Message = lazy(() => import(`globalcomponents/UI/Message/${layout}`));

const StreamingStatus = ({
  row,
  cameraStatus,
  fetchCameraStatus,
  apiStatus,
  fetchVehicles
}) => {
  const i18n = useTranslation();
  const [status, setStatus] = useState(null);

  const generateStatusRows = (data) => {
    data.cameraStatus = data.isOnline ? 'Online' : 'Offline';
    data.lastConnectTime = moment(new Date(data.lastConnectTime)).format(
      'MM/DD/YYYY HH:mm:ss'
    );
    data.lastDisconnectTime = moment(new Date(data.lastDisconnectTime)).format(
      'MM/DD/YYYY HH:mm:ss'
    );
    return [data];
  };

  const cloumns = useMemo(() => {
    return getConfig(i18n).tableColumns;
  }, []);

  const hasUserListApiStatus = hasValue(apiStatus.status, 'api', fetchVehicles);
  const information =
    hasUserListApiStatus && hasUserListApiStatus.errorMessage ? (
      <Message
        type="error"
        message={i18n.t(hasUserListApiStatus.errorMessage)}
      />
    ) : (
      i18n.t('common.tableEmptyMessage')
    );

  const getContent = () => {
    if (cameraStatus) {
      return {
        content: () => (
          <div className="descModal">
            <div style={{ fontWeight: 'unset' }} className="headWrapper">
              {`Unit ID - `}
              <span style={{ fontWeight: '600' }}>{row?.unit_id}</span>
            </div>
            {Object.entries(cameraStatus).length > 0 ? (
              <>
                <div className="headWrapper">
                  {i18n.t('camera.cameraStatus')}
                </div>
                <Table
                  type="client"
                  defaultSortBy={{ sortBy: 'date', order: 'desc' }}
                  title=""
                  columns={cloumns || []}
                  data={generateStatusRows(cameraStatus)}
                  emptyMessage={information}
                  id="cameraStatusPopUp"
                  actions={[]}
                  noPagination
                  i18n={i18n}
                />
              </>
            ) : (
              <div style={{ textAlign: 'center' }} className="headWrapper">
                No Status available
              </div>
            )}
          </div>
        )
      };
    }

    // Default Case: Fallback content
    return {
      content: () => (
        <div className="descModal">
          <div style={{ fontWeight: 'unset' }} className="headWrapper">
            {`Unit ID - `}
            <span style={{ fontWeight: '600' }}>{row.unit_id}</span>
          </div>
          <div style={{ textAlign: 'center' }} className="headWrapper">
            No Status available
          </div>
        </div>
      )
    };
  };

  const onStatus = async () => {
    fetchCameraStatus({
      apiId: 'cameraStatusApi',
      cameraSerialNo: row?.cameraSerialNo,
      cameraType: row?.cameraType,
    });
    setStatus(row);
  };

  return (
    <>
      <div style={{ display: row.cameraSerialNo ? '' : 'none' }}>
        <Icon
          src={mediaUrls?.viewStatus}
          tooltip="Status"
          onClick={onStatus}
        />
      </div>
      {status && (
        <Modal
          open={true}
          setOpen={setStatus}
          data={getContent()}
          withCloseIcon
          width={'800px'}
          alignItemsLeft
          removeTopSpace
        />
      )}
    </>
  );
};

export default StreamingStatus;
